import React from "react";
import HeroSectionStyle from "../../components/Sections/HeroSectionStyle";
import { Box } from "@mui/material";
import { ASSETS_PATH } from "../../utils/constants";

export default function HeroSection({ id }) {
  return (
    <>
      <HeroSectionStyle
        title="THE CRAFTSMEN THEMSELVES"
        id={id}
        p="We redefine business transformation through our unique craftsmanship-driven approach with timeless business principles."
      />

      <Box className="container-fluid" sx={{ mt: 9.5 }}>
        <img
          src={ASSETS_PATH + "home_hero.jpeg"}
          alt="hero"
          style={{ width: "100%" }}
        />
      </Box>
    </>
  );
}
